<!-- ── En-tête bénéficiaire ── -->
<div class="hub-benef">
  <i class="material-icons-outlined hub-benef-icon">person</i>
  <div>
    <div class="hub-benef-name">{{ beneficiaire?.prenom }} {{ beneficiaire?.nom }}</div>
    <div class="hub-benef-mat">{{ beneficiaire?.matricule }}</div>
  </div>
  <button class="hub-close-btn ms-auto" (click)="onClose.emit()">×</button>
</div>

<!-- ── Grille des activités ── -->
<div class="hub-grid">
  <button *ngFor="let col of visibleCols" class="hub-act-btn" (click)="ouvrirPrescrire(col)">
    <i class="material-icons-outlined hub-act-icon">{{ col.icon }}</i>
    <span>{{ col.label }}</span>
  </button>
</div>

<!-- ── Modal prescription ── -->
<div *ngIf="showPrescModal" class="presc-overlay">
  <div class="presc-modal" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="presc-header">
      <div class="presc-header-main">
        <span class="presc-header-title">
          <i class="material-icons-outlined" style="font-size:1rem;vertical-align:middle">{{ prescCol?.icon }}</i>
          {{ prescCol?.label }}
        </span>
        <span *ngIf="hospitId" class="presc-header-hospit">
          <i class="material-icons-outlined" style="font-size:0.9rem;vertical-align:middle">hotel</i>
          Hospit. — {{ beneficiaire?.prenom }} {{ beneficiaire?.nom }}
          <span style="opacity:0.75;font-size:0.78rem">&nbsp;({{ beneficiaire?.matricule }})</span>
        </span>
      </div>
      <button class="close-btn" (click)="fermerPrescModal()">×</button>
    </div>

    <!-- Navbar activités -->
    <div class="presc-navbar">
      <button *ngFor="let col of visibleCols" class="presc-nav-tab" [class.active]="col.codif === prescCol?.codif"
        (click)="ouvrirPrescrire(col)">
        <i class="material-icons-outlined">{{ col.icon }}</i>
        <span>{{ col.label }}</span>
      </button>
    </div>

    <!-- Body -->
    <div class="presc-body" [class.presc-body-special]="prescCol?.codif === 'OPT' || prescCol?.codif === 'DEN'">

      <!-- ── OPTIQUE ── -->
      <ng-container *ngIf="prescCol?.codif === 'OPT'">
        <app-form-pres-optique [matricule]="beneficiaire?.matricule" [consultation]="consultation"></app-form-pres-optique>
      </ng-container>

      <!-- ── DENTISTERIE ── -->
      <ng-container *ngIf="prescCol?.codif === 'DEN'">
        <app-form-pres-dentisterie [matricule]="beneficiaire?.matricule" [praticienId]="consultation?.praticien_id"></app-form-pres-dentisterie>
      </ng-container>

      <!-- ── ORDONNANCE / ACTES ── -->
      <ng-container *ngIf="prescCol?.codif !== 'OPT' && prescCol?.codif !== 'DEN'">

      <!-- ── ORDONNANCE ── -->
      <ng-container *ngIf="prescCol?.isOrdonnance; else actesForm">

        <!-- Section contexte : Affection + Praticien + Légende -->
        <div class="presc-section mb-2">
          <div class="row g-2 mb-2">
            <div class="col-6">
              <label class="presc-field-label">Affection</label>
              <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id"
                [(ngModel)]="prescForm.affection_id" placeholder="Sélectionner l'affection" [searchable]="true">
              </ng-select>
            </div>
            <div class="col-6">
              <label class="presc-field-label">Praticien</label>
              <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id"
                [(ngModel)]="prescForm.praticien_id" placeholder="Sélectionnez le praticien" [searchable]="true">
              </ng-select>
            </div>
          </div>
          <div class="legende-row">
            <span class="leg-pill leg-danger">Non garanti</span>
            <span class="leg-pill leg-warning">Entente préalable</span>
            <span class="leg-pill leg-success">Garanti</span>
          </div>
        </div>

        <!-- ── Barre ajout médicament ── -->
        <div class="add-medoc-bar mb-2">

          <!-- Ligne principale : médicament + qté + durée -->
          <div class="add-medoc-main">
            <div class="add-medoc-search">
              <label class="form-label form-label-sm mb-1">Médicament</label>
              <app-search-mdicament-pro [cancelItemSelected]="cancelMedocSelected" [defaultItem]="defaultMedocItem"
                (itemMedicamentSelected)="onSelectMedoc($event)">
              </app-search-mdicament-pro>
            </div>
            <div class="add-medoc-qty">
              <label class="form-label form-label-sm mb-1">Qté</label>
              <div class="qty-cond-row">
                <input type="number" class="qty-num" [(ngModel)]="medocForm.quantite" min="1">
                <select class="qty-unit-sel form-control" [(ngModel)]="medocForm.unite_cond">
                  <option *ngFor="let u of condUniteOptions" [value]="u">{{ u }}</option>
                </select>
              </div>
            </div>
            <div class="add-medoc-duree">
              <label class="form-label form-label-sm mb-1">Durée (j)</label>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="medocForm.duree" min="1">
            </div>
          </div>

          <!-- Info conditionnement -->
          <div *ngIf="selectedMedocItem?.id && selectedMedocItem?.conditionnement" class="cond-info">
            <i class="fas fa-box-open me-1"></i>
            Conditionnement&nbsp;: <strong>{{ selectedMedocItem.conditionnement }}</strong>
          </div>

          <!-- Avertissement doublon -->
          <div *ngIf="isDuplicate" class="dup-warning">
            <i class="fas fa-exclamation-triangle me-1"></i>
            Ce médicament est déjà dans l'ordonnance
          </div>

          <!-- Constructeur de posologie (visible dès qu'un médicament est sélectionné) -->
          <div class="pos-section" [class.pos-disabled]="!selectedMedocItem?.id">

            <div class="pos-header">
              <span class="pos-label">Posologie</span>
              <div class="pos-mode-btns">
                <button class="pos-mode-btn" [class.active]="posMode==='builder'" (click)="switchMode('builder')">
                  <i class="fas fa-sliders-h me-1"></i>Constructeur
                </button>
                <button class="pos-mode-btn" [class.active]="posMode==='libre'" (click)="switchMode('libre')">
                  <i class="fas fa-keyboard me-1"></i>Texte libre
                </button>
              </div>
            </div>

            <!-- ── Mode constructeur ── -->
            <div *ngIf="posMode==='builder'" class="pos-builder">

              <div class="pos-row1">
                <div class="pos-dose-group">
                  <label class="pos-micro-label">Dose</label>
                  <div class="pos-dose-inputs">
                    <input type="number" class="pos-dose-num" [(ngModel)]="posBuilder.dose" min="0.5" step="0.5">
                    <select class="pos-unite-sel" [(ngModel)]="posBuilder.unite">
                      <option *ngFor="let u of uniteOptions" [value]="u">{{ u }}</option>
                    </select>
                  </div>
                </div>
                <div class="pos-freq-group">
                  <label class="pos-micro-label">Fréquence</label>
                  <select class="pos-freq-sel" [(ngModel)]="posBuilder.freq">
                    <option *ngFor="let f of freqOptions" [value]="f.val">{{ f.label }}</option>
                  </select>
                </div>
              </div>

              <div class="pos-row2">
                <label class="pos-micro-label">Moment de prise</label>
                <div class="pos-timing">
                  <label class="pos-chip" [class.active]="posBuilder.matin">
                    <input type="checkbox" [(ngModel)]="posBuilder.matin"> Matin
                  </label>
                  <label class="pos-chip" [class.active]="posBuilder.midi">
                    <input type="checkbox" [(ngModel)]="posBuilder.midi"> Midi
                  </label>
                  <label class="pos-chip" [class.active]="posBuilder.soir">
                    <input type="checkbox" [(ngModel)]="posBuilder.soir"> Soir
                  </label>
                  <label class="pos-chip" [class.active]="posBuilder.coucher">
                    <input type="checkbox" [(ngModel)]="posBuilder.coucher"> Coucher
                  </label>
                </div>
              </div>

              <div class="pos-row3">
                <label class="pos-micro-label">Par rapport aux repas</label>
                <div class="pos-repas">
                  <label *ngFor="let r of repasOptions" class="pos-chip" [class.active]="posBuilder.repas===r.val">
                    <input type="radio" name="posRepas" [(ngModel)]="posBuilder.repas" [value]="r.val"> {{ r.label }}
                  </label>
                </div>
              </div>

              <!-- Bouton ajouter (mode constructeur) -->
              <div class="add-medoc-action" style="align-self:flex-end;">
                <button class="btn btn-sm btn-success btn-add-medoc" (click)="addMedocToCart()">
                  <i class="fas fa-plus me-1"></i> Ajouter
                </button>
              </div>

              <div class="pos-preview">
                <i class="fas fa-arrow-right pos-arrow"></i>
                <span class="pos-generated">{{ buildPosologieText() }}</span>
              </div>
            </div>

            <!-- ── Mode texte libre ── -->
            <div *ngIf="posMode==='libre'" class="pos-libre d-flex gap-2 align-items-end">
              <textarea class="form-control form-control-sm" style="width:50%;" rows="2" [(ngModel)]="posTexteLibre"
                placeholder="Ex: 1 comprimé 3 fois/jour pendant 7 jours..."></textarea>
              <div class="add-medoc-action flex-shrink-0">
                <button class="btn btn-sm btn-success btn-add-medoc" (click)="addMedocToCart()">
                  <i class="fas fa-plus me-1"></i> Ajouter
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- Panier médicaments -->
        <div class="cart-wrapper mb-2">
          <table class="medication-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Médicament</th>
                <th>Forme</th>
                <th>Posologie</th>
                <th>Qté</th>
                <th>Durée</th>
                <th>Renouveler?</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let m of itemsMedicament; let i = index" [class]="rowClass(m)">
                <td>{{ i + 1 }}</td>
                <td>{{ m.medicament_libelle }}</td>
                <td><span class="forme-tag">{{ m.forme_medicament_libelle }}</span></td>
                <td class="posologie-cell" (click)="selectedPosologie = m.posologie">
                  <span class="posologie-truncated" [title]="m.posologie">{{ m.posologie }}</span>
                </td>
                <td class="qty-cell">{{ m.quantite }}&nbsp;<span class="qty-unit-badge">{{ m.unite_cond }}</span></td>
                <td>{{ m.duree }}j</td>
                <td>
                  <div style="position:relative;display:inline-block;width:100%;">
                    <select class="form-select form-select-sm" [(ngModel)]="m.is_renewable"
                      [ngModelOptions]="{standalone:true}"
                      (change)="(m.is_renewable == 1 || m.is_renewable === '1') ? selectedDetailItem = m : null">
                      <option value="0">Non</option>
                      <option value="1">Oui</option>
                    </select>
                    <span *ngIf="(m.is_renewable == 1 || m.is_renewable === '1') && m.frequence_renew && m.duree_renew && +m.duree_renew > +m.frequence_renew"
                      class="renew-count-badge">
                      {{ (m.duree_renew / m.frequence_renew) | number:'1.0-0' }}×
                    </span>
                  </div>
                </td>
                <td class="actions-cell">
                  <div class="actions-inner">
                    <button class="btn-edit" (click)="editMedoc(i)" title="Modifier">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                    <button class="btn btn-xs"
                      [class.btn-info]="m.is_renewable == 1 || m.is_renewable === '1'"
                      [class.btn-outline-secondary]="m.is_renewable != 1 && m.is_renewable !== '1'"
                      [disabled]="m.is_renewable != 1 && m.is_renewable !== '1'"
                      (click)="selectedDetailItem = m; $event.stopPropagation()"
                      title="Détail renouvellement">
                      <i class="fas fa-sync-alt"></i>
                    </button>
                    <button class="btn-remove" (click)="removeMedoc(i)" title="Supprimer">✕</button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!itemsMedicament.length">
                <td colspan="8" class="empty-cart-row">Aucun médicament ajouté</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <!-- ── ACTES ── -->
      <ng-template #actesForm>

        <!-- Affection + Praticien en première ligne -->
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="form-label form-label-sm">Affection</label>
            <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id" [(ngModel)]="prescForm.affection_id"
              placeholder="Sélectionner l'affection" [searchable]="true">
            </ng-select>
          </div>
          <div class="col-6">
            <label class="form-label form-label-sm">Praticien</label>
            <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id"
              [(ngModel)]="prescForm.praticien_id" placeholder="Sélectionnez le praticien" [searchable]="true">
            </ng-select>
          </div>
        </div>

        <!-- Ligne ajout acte -->
        <div class="row g-2 mb-2 align-items-end">
          <div class="col-6">
            <label class="form-label form-label-sm mb-1">Acte</label>
            <ng-select [items]="itemsActeModal" bindLabel="libelle" [(ngModel)]="selectedActeItem"
              placeholder="Sélectionner un acte" [searchable]="true" [loading]="loadingActes">
            </ng-select>
          </div>
          <div class="col-auto">
            <button class="btn btn-sm btn-success" (click)="addActeToCart()">+ Ajouter</button>
          </div>
        </div>

        <!-- Liste actes -->
        <div class="cart-wrapper mb-2">
          <div *ngIf="!selectedActes.length" class="empty-cart">Aucun acte sélectionné</div>
          <table *ngIf="selectedActes.length" class="cart-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Acte</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of selectedActes; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ a.acte_libelle }}</td>
                <td><button class="btn-remove" (click)="removeActe(i)">✕</button></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Renseignement clinique -->
        <div class="row g-2">
          <div class="col-12">
            <label class="form-label form-label-sm">Renseignement clinique</label>
            <textarea class="reason-input" rows="2" [(ngModel)]="prescForm.renseignement_clinique"
              placeholder="Renseignement clinique..."></textarea>
          </div>
        </div>
      </ng-template>
      </ng-container><!-- /ORDONNANCE / ACTES -->

    </div>

    <!-- Footer (masqué pour OPT et DEN qui ont leur propre bouton) -->
    <div class="presc-footer" *ngIf="prescCol?.codif !== 'OPT' && prescCol?.codif !== 'DEN'">
      <button class="btn btn-sm btn-outline-secondary" (click)="annulerSaisie()">Annuler</button>
      <button class="btn btn-sm btn-primary" (click)="confirmPrescrire()" [disabled]="savingPresc">
        <span *ngIf="savingPresc" class="spinner-border spinner-border-sm me-1"></span>
        Enregistrer
      </button>
    </div>
  </div>
</div>

<!-- ── Popup renouvellement ── -->
<div *ngIf="selectedDetailItem" class="posologie-overlay" style="z-index:4000;">
  <div class="posologie-popup detail-popup" (click)="$event.stopPropagation()">
    <div class="posologie-popup-header">
      <span><i class="fas fa-sync-alt me-1"></i>Renouvellement — {{ selectedDetailItem.medicament_libelle }}</span>
      <button (click)="selectedDetailItem = null">×</button>
    </div>
    <div class="posologie-popup-body">
      <div class="detail-grid">
        <div class="detail-field">
          <label>Renouveler tous les (jours)</label>
          <input type="number" min="1" class="form-control form-control-sm"
            [(ngModel)]="selectedDetailItem.frequence_renew" [ngModelOptions]="{standalone:true}"
            [disabled]="selectedDetailItem.is_renewable == 0"
            (keypress)="'0123456789'.includes($event.key) ? true : $event.preventDefault()">
        </div>
        <div class="detail-field">
          <label>Durée renouvellement (jr)</label>
          <input type="number" min="1" class="form-control form-control-sm"
            [(ngModel)]="selectedDetailItem.duree_renew" [ngModelOptions]="{standalone:true}"
            [disabled]="selectedDetailItem.is_renewable == 0"
            (keypress)="'0123456789'.includes($event.key) ? true : $event.preventDefault()"
            [class.is-invalid]="selectedDetailItem.duree_renew && selectedDetailItem.frequence_renew && +selectedDetailItem.duree_renew <= +selectedDetailItem.frequence_renew">
          <div class="invalid-feedback" style="font-size:11px;">La durée doit être supérieure à la fréquence.</div>
        </div>
        <div class="detail-field">
          <label>Quantité à renouveler
            <span *ngIf="selectedDetailItem.quantite" style="font-size:10px;color:#888;">(max : {{ selectedDetailItem.quantite }})</span>
          </label>
          <input type="number" min="1" class="form-control form-control-sm"
            [(ngModel)]="selectedDetailItem.quantite_renew" [ngModelOptions]="{standalone:true}"
            [disabled]="selectedDetailItem.is_renewable == 0"
            (keypress)="'0123456789'.includes($event.key) ? true : $event.preventDefault()"
            [class.is-invalid]="selectedDetailItem.quantite_renew && selectedDetailItem.quantite && +selectedDetailItem.quantite_renew > +selectedDetailItem.quantite">
          <div class="invalid-feedback" style="font-size:11px;">Ne peut pas dépasser la quantité prescrite ({{ selectedDetailItem.quantite }}).</div>
        </div>
        <div class="detail-field">
          <label>Consultation préalable ?</label>
          <select class="form-select form-select-sm"
            [(ngModel)]="selectedDetailItem.is_consultation_required_renew" [ngModelOptions]="{standalone:true}"
            [disabled]="selectedDetailItem.is_renewable == 0">
            <option value="0">Non</option>
            <option value="1">Oui</option>
          </select>
        </div>
      </div>
      <div class="renew-summary"
        *ngIf="selectedDetailItem.frequence_renew && selectedDetailItem.duree_renew && +selectedDetailItem.duree_renew > +selectedDetailItem.frequence_renew">
        <i class="fas fa-sync-alt me-1"></i>
        Renouvellements possibles :
        <strong>{{ (selectedDetailItem.duree_renew / selectedDetailItem.frequence_renew) | number:'1.0-0' }}</strong> fois
        <span class="text-muted" style="font-size:11px;">
          ({{ selectedDetailItem.duree_renew }} jr ÷ {{ selectedDetailItem.frequence_renew }} jr)
        </span>
        <div class="renew-dates-list">
          <span *ngFor="let d of renewalDates; let i = index" class="renew-date-chip">
            <i class="fas fa-calendar-alt"></i> R{{ i + 1 }} — {{ d }}
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-primary btn-sm px-4" (click)="selectedDetailItem = null">
          <i class="fas fa-check me-1"></i> OK
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ── Popup posologie ── -->
<div *ngIf="selectedPosologie" class="posologie-overlay" (click)="selectedPosologie = ''">
  <div class="posologie-popup" (click)="$event.stopPropagation()">
    <div class="posologie-popup-header">
      <span>Posologie</span>
      <button (click)="selectedPosologie = ''">×</button>
    </div>
    <div class="posologie-popup-body">{{ selectedPosologie }}</div>
  </div>
</div>